import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Models
import mDevice from 'models/device';
// Custom
import { deviceDataShape, scenarioTriggerDataShape } from 'constants/PropTypesShapes';

const ScenarioTriggerLabel = ({ device, scenarioTrigger }) => {
  const trigger = mDevice.trigger(scenarioTrigger.trigger_id, device);
  const { equipment } = trigger;
  const triggerName = equipment ? equipment.name : <LocalizedMessage id="info.deviceSlaveTrigger" values={{ triggerType: trigger.type }} />;
  const scenarioTriggerType = <LocalizedMessage id={`scenarioTrigger.type.${scenarioTrigger.type}`} />;

  return (
    <div>
      {triggerName}
      {' '}
      (
      {scenarioTriggerType}
      )
    </div>
  );
};

ScenarioTriggerLabel.propTypes = {
  device: deviceDataShape.isRequired,
  scenarioTrigger: scenarioTriggerDataShape.isRequired,
};

module.exports = ScenarioTriggerLabel;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/scenarios/ScenarioTriggerLabel.js